<template lang="pug">
  bloco#categorias.-padding-desktop
    //- HEADER
    header(slot="header")
      titulo.-withbar.-upper Documentos
      p Aqui você encontrará os documentos para download
    //- CONTENT
    .conteudo(slot="content")
      lista.categorias(:itens="categorias", :rota="'Documentos'", :icone="'pasta'", v-if='!naoTemCategorias')
    //- FEEDBACK
    template(slot="feedback", v-if='naoTemCategorias')
      br
      mensagem.-warn
        p Nenhum documento foi encontrado no momento
</template>

<style lang="scss">
  #categorias {
    .conteudo {
      > .lista {
        margin: 20px 0 50px 0;
        > .item {
          margin: 20px 0;
          @extend %font_medium;
          font-size: 18px;
          &:before {
            font-family: 'FontAwesome';
            font-size: 1.7rem;
            color: $color-blue-dark;
            margin-right: 15px;
          }

          &.pasta:before { content: '\f07b' }
          &.arquivo:before { content: '\f15b' }
        }
      }
    }
  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import Mensagem from 'COMPONENTS/Mensagem'
import Titulo from 'COMPONENTS/ElementTitle'
import DocumentoService from '../../js/api/DocumentoService'
import Lista from 'COMPONENTS/BaseLista'

export default {
  components: {
    Bloco,
    Mensagem,
    Titulo,
    Lista
  },
  props: ['unidade'],
  data () {
    return {
      categorias: [],
      naoTemCategorias: false
    }
  },
  methods: {
    loadCategorias (unidade = 'proad') {
      let categoriasData = []
      DocumentoService.getCategorias(unidade)
      .then(categorias => {
        categorias.data.forEach(function (categoria) {
          categoriasData.push({
            id: categoria.id,
            nome: categoria.name,
            slug: categoria.slug
          })
        })
        if (categoriasData.length === 0) {
          this.naoTemCategorias = true
        }
      })
      return categoriasData
    }
  },
  mounted: function () {
    this.categorias = this.loadCategorias(this.unidade)
  }
}
</script>



// WEBPACK FOOTER //
// Categorias.vue?7182fe82